<template>
  <Accordion :value="['0', '1', '2']" class="mx-auto p-4" multiple v-if="item">
    <AccordionPanel value="0">
      <AccordionHeader>
        <div class="text-primary text-md flex items-center">
          <span class="fa fa-circle-info mr-2"></span>
          <span>THÔNG TIN CHUNG</span>
        </div>
      </AccordionHeader>
      <AccordionContent>
        <div class="grid grid-cols-3 md:grid-cols-6 gap-2">

          <KeyValueColSpan label="Điện thoại" :value="item.dienthoai || ''">
          </KeyValueColSpan>


          <KeyValueColSpan label="Tọa độ" :value="item.toado?.map(e =>
            parseFloat(e).toFixed(6)).join(',')
            || 'Không có thông tin'" isLatlon>
          </KeyValueColSpan>


          <KeyValueColSpan label="Email" :value="item.email || ''">
          </KeyValueColSpan>


          <KeyValueColSpan label="Địa chỉ" :value="item.diachi || ''">
          </KeyValueColSpan>
        </div>
      </AccordionContent>
    </AccordionPanel>
    <AccordionPanel value="1" class="mt-1">
      <AccordionHeader>
        <div class="text-primary text-md flex items-center">
          <span class="fa fa-chart-simple mr-2"></span>
          <span>THỐNG KÊ TỔNG QUAN</span>
        </div>
      </AccordionHeader>
      <AccordionContent>
        <div>
          <div class="grid grid-cols-2 md:grid-cols-4 gap-2">

            <AvatarIconWithLabel label="Số trường" :value="item.so_luong.so_truong || 0" col-span-label="col-span-2"
              icon="fa fa-users-rectangle"></AvatarIconWithLabel>

            <AvatarIconWithLabel label="Số giáo viên" :value="item.so_luong.giao_vien || 0" col-span-label="col-span-2"
              icon="fa fa-users-rectangle"></AvatarIconWithLabel>

            <AvatarIconWithLabel label="Số lớp học" :value="item.so_luong.lop_hoc || 0" col-span-label="col-span-2"
              icon="fa fa-chalkboard">
            </AvatarIconWithLabel>

            <AvatarIconWithLabel label="Số học sinh" :value="item.so_luong.so_hocsinh || 0" col-span-label="col-span-2"
              icon="fa fa-users-line">
            </AvatarIconWithLabel>


            <AvatarIconWithLabel label="Số h/s nam" :value="item.so_luong.so_nam || 0" col-span-label="col-span-2"
              icon="fa fa-mars-double">
            </AvatarIconWithLabel>

            <AvatarIconWithLabel label="Số h/s nữ" :value="item.so_luong.so_nu || 0" col-span-label="col-span-2"
              icon="fa fa-venus-double">
            </AvatarIconWithLabel>

            <AvatarIconWithLabel label="Số h/s chính sách" :value="item.so_luong.so_dienchinhsach || 0"
              :subValue="`${percentValue(item.so_luong.so_dienchinhsach || 0, item.so_luong.so_hocsinh || 0)}%`"
              icon="fa fa-hand-holding-hand">
            </AvatarIconWithLabel>

            <AvatarIconWithLabel label="Số h/s cận nghèo" :value="item.so_luong.so_canngheo || 0"
              :subValue="`${percentValue(item.so_luong.so_canngheo || 0, item.so_luong.so_hocsinh || 0)}%`"
              icon="fa fa-hands-holding-child">
            </AvatarIconWithLabel>
            <!-- 
          <KeyValueColSpan v-for="itemDanToc in item.so_luong.dantoc" :label="`Dân tộc ${itemDanToc.dan_toc}`"
            :value="itemDanToc.so_luong" :key="itemDanToc.dantoc_id" col-span-label="col-span-2" col-span-value="col-span-1">
          </KeyValueColSpan> -->
          </div>
          <div class="grid grid-cols-1 md:grid-cols-3 mt-4 gap-2">
            <div class="card shadow-md">
              <h6 class="text-center">DÂN TỘC</h6>
              <div class="w-full flex justify-center">
                <Chart type="pie" :data="chartDataTruongDanToc" :options="chartOptionsPie" class="w-full h-[20rem]"
                  :plugins="plugins" />
              </div>
            </div>
            <div class="card shadow-md">
              <h6 class="text-center">GIỚI TÍNH</h6>
              <div class="w-full flex justify-center">
                <Chart type="pie" :data="chartDataTruongGioiTinh" :options="chartOptionsPie" class="w-full h-[20rem]"
                  :plugins="plugins" />
              </div>
            </div>
            <div class="card shadow-md">
              <h6 class="text-center">SỐ LIỆU TRUNG BÌNH</h6>
              <div v-for="(item, index) in itemTiTrong"
                class="flex md:flex-row flex-col md:justify-between md:items-center items-end p-4"
                :class="[index % 2 == 1 ? 'bg-surface-50 dark:bg-surface-800' : '']">
                <span class="flex items-center">
                  <Avatar :icon="item.icon" :class="[item.bgColor, 'mr-2 text-white']" shape="circle" size="large" />
                  <span>{{
                    item.ten }}</span>
                </span>
                <span class="font-medium" :class="[item.textColor]">{{ item.gia_tri }}</span>
              </div>
            </div>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-5 mt-4 gap-2">
            <div class="col-span-5 md:col-span-2">
              <div class="card shadow-md">
                <h6 class="text-center">ĐỘ TUỔI/GIỚI TÍNH GIÁO VIÊN</h6>
                <div class="w-full flex justify-center">
                  <Chart type="bar" :data="chartDataGiaoVienTuoiGioiTinh" :options="chartOptionsGiaoVienTuoiGioiTinh"
                    class="w-full h-[20rem]" :plugins="plugins" />
                </div>
              </div>
            </div>
            <div class="col-span-5 md:col-span-3">
              <div class="card shadow-md">
                <h6 class="text-center">GIÁO VIÊN/NHIỆM VỤ</h6>
                <div class="w-full flex justify-center">
                  <Chart type="line" :data="chartDataGiaoVienBoMon" :options="chartOptionsBoMon"
                    class="w-full h-[20rem]" />
                </div>
              </div>
            </div>
          </div>

        </div>
      </AccordionContent>
    </AccordionPanel>
    <AccordionPanel value="2" class="mt-1">
      <AccordionHeader>
        <div class="text-primary text-md flex items-center">
          <span class="fa fa-chart-pie mr-2"></span>
          <span>THỐNG KÊ THEO TRƯỜNG</span>
        </div>
      </AccordionHeader>
      <AccordionContent>


        <div>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div class="col-span-2 md:col-span-1">
              <div class="card shadow-md">
                <h6 class="text-center">CẤP HỌC</h6>
                <div class="w-full flex justify-center">
                  <Chart type="doughnut" :data="chartDataCapHoc" :options="chartOptionsPie" class="w-full h-[20rem]"
                    :plugins="plugins" />
                </div>
              </div>
            </div>

            <div class="col-span-2 md:col-span-1">
              <div class="card shadow-md">
                <h6 class="text-center">LOẠI HÌNH</h6>
                <div class="w-full flex justify-center">
                  <Chart type="doughnut" :data="chartDataLoaiHinh" :options="chartOptionsPie" class="w-full h-[20rem]"
                    :plugins="plugins" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </AccordionContent>
    </AccordionPanel>
  </Accordion>
</template>

<script setup>
const { $api } = useNuxtApp()
const props = defineProps({
  item: {
    type: Object,
    required: true
  },
});
import ChartDataLabels from 'chartjs-plugin-datalabels';
// import ChartZoom from 'chartjs-plugin-zoom';
const plugins = [ChartDataLabels];

const chartDataTruongDanToc = ref()
const chartDataTruongGioiTinh = ref()

const chartOptionsPie = ref({
  maintainAspectRatio: false,
  aspectRatio: 2,
  responsive: true,
  plugins: {
    layout: {
      padding: {
        right: 10   // Khoảng cách từ bên phải biểu đồ
      }
    },
    legend: {
      position: 'top',
      labels: {
        font: {
          size: 11, // Kích thước font chữ
        },
      },
    },
    datalabels: {
      formatter: (value, ctx) => {
        let sum = 0;
        let dataArr = ctx.chart.data.datasets[0].data;
        dataArr.map((data) => {
          sum += data;
        });
        let percentage = (value * 100) / sum == 0 ? '' : ((value * 100) / sum).toFixed(2) + '%';
        return percentage;
      },
      display: function (context) {
        return Math.abs(context.dataset.data[context.dataIndex]) > 5;
      },
      labels: {
        anchor: 'start',
        value: {
          color: 'white',
          font: {
            weight: 'bold'
          }
        }
      }
    }
  }
});

const chartDataGiaoVienTuoiGioiTinh = ref()
const chartOptionsGiaoVienTuoiGioiTinh = ref();

const setChartDataGiaoVienTuoiGioiTinh = () => {
  const theme = chartTheme.theme4
  const gioitinh = props.item.giao_vien

  return {
    labels: gioitinh.map((r) => r.dotuoi),
    datasets: [
      {
        label: 'Nam',
        data: gioitinh.map((r) => convertToNegative(r.nam)),
        backgroundColor: theme[0],
      },
      {
        label: 'Nữ',
        data: gioitinh.map((r) => r.nu),
        backgroundColor: theme[1],
      }
    ],
  };
}

const setChartOptionsGiaoVienTuoiGioiTinh = () => {
  const gioitinh = props.item.giao_vien
  const dataNam = gioitinh.map((r) => r.nam)
  const dataNu = gioitinh.map((r) => r.nu)

  const allData = [...dataNam, ...dataNu];  // Kết hợp cả Nam và Nữ
  const maxAll = Math.max(...allData) + 5;  // Tìm max của tất cả dữ liệu

  return {
    responsive: true,
    maintainAspectRatio: false,
    aspectRatio: 5 / 3,
    layout: {
      padding: {
        top: 24,
        right: 16,
        bottom: 0,
        left: 8
      }
    },
    indexAxis: 'y',
    scales: {
      x: {
        beginAtZero: true,
        min: maxAll * - 1,             // Đảm bảo trục X có đủ không gian cho các giá trị âm
        max: maxAll,
        grid: {
          display: false,
          drawBorder: false
        },
        stacked: true,
        ticks: {
          callback: function (value) {
            return Math.abs(value); // Hiển thị giá trị tuyệt đối trên trục x
          },
        },
      },
      y: {
        beginAtZero: true,
        stacked: true
      }
    },
    plugins: {
      datalabels: {
        color: 'white',
        display: function (context) {
          return Math.abs(context.dataset.data[context.dataIndex]) > 15;
        },
        font: {
          weight: 'bold'
        },
        formatter: function (value, context) {
          return Math.abs(value);
        }
      },
      tooltip: {
        callbacks: {
          label: (c) => {
            const value = Number(c.raw);
            const positiveOnly = value < 0 ? -value : value;
            return `${c.dataset.label}: ${positiveOnly.toString()}`;
          },
        },
      },
    },
  }
}

const chartDataGiaoVienBoMon = ref()
const chartOptionsBoMon = ref({
  responsive: true,
  maintainAspectRatio: false,
  aspectRatio: 0.8,
  plugins: {

    datalabels: {
      color: 'white',
      display: function (context) {
        return Math.abs(context.dataset.data[context.dataIndex]) > 15;
      },
      font: {
        weight: 'bold'
      },
      formatter: function (value, context) {
        return Math.abs(value);
      }
    },
  },
  scales: {
    x: {
      ticks: {
        font: {
          weight: 500
        }
      },
      grid: {
        display: false,
        drawBorder: false
      }
    },
    y: {
      ticks: {
      },
      grid: {
        drawBorder: false
      }
    }
  }
})

const setChartDataGiaoVienBoMon = () => {
  const theme = chartTheme.theme3
  const bomon = props.item.bo_mon

  return {
    labels: bomon.map(e => e.ten_to_bomon),
    datasets: [
      {
        label: 'Số giáo viên',
        data: bomon.map(e => e.so_giaovien),
        backgroundColor: theme[0],
      }
    ],
  };
}

const setChartDataTruongDanToc = () => {
  const theme = chartTheme.theme2
  const dantocs = props.item.so_luong.dantoc
  const labels = []
  const datasets = [{
    data: [],
    backgroundColor: [],
  }]
  dantocs.forEach((dantoc, i) => {
    labels.push(dantoc.dan_toc)
    datasets[0].data.push(dantoc.so_luong)
    datasets[0].backgroundColor.push(theme[i])
  })
  return {
    labels, datasets
  }
}

const setChartDataTruongGioiTinh = () => {
  const theme = chartTheme.theme2
  const soluong = props.item.so_luong
  return {
    labels: ['Nam', 'Nữ'],
    datasets: [
      {
        data: [soluong?.so_nam || 0, soluong?.so_nu || 0],
        backgroundColor: [theme[5], theme[6]]
      }
    ]
  }
}

const chartDataKhoiGioiTinh = ref();
const chartOptionsKhoiGioiTinh = ref();

const setChartDataKhoiGioiTinh = () => {
  const theme = chartTheme.theme1
  const khoiData = props.item.so_khoi
  const labels = khoiData.map(e => e.ten_khoi)
  const dataNam = khoiData.map(e => e.so_nam)
  const dataNu = khoiData.map(e => e.so_nu)
  return {
    labels: labels,
    datasets: [
      {
        type: 'bar',
        label: 'Nam',
        backgroundColor: theme[0],
        data: dataNam
      },
      {
        type: 'bar',
        label: 'Nữ',
        backgroundColor: theme[1],
        data: dataNu
      }
    ]
  }
};


const chartDataKhoiDanToc = ref();
const chartOptionsKhoiDanToc = ref();


const getDistinctDanToc = (data, key = 'dantoc') => {
  const dantocSet = new Set();

  data.forEach(khoi => {
    khoi[key].forEach(dantoc => {

      dantocSet.add(JSON.stringify({
        dantoc_id: dantoc.dantoc_id,
        dan_toc: dantoc.dan_toc ?? dantoc.dm_dantoc.dan_toc
      }));
    });
  });

  return Array.from(dantocSet).map(dantoc => JSON.parse(dantoc));
}

const setChartDataKhoiDanToc = () => {
  const theme = chartTheme.theme3
  const khoiData = props.item.so_khoi
  const labels = khoiData.map(e => e.ten_khoi)
  const labelsDatasetVisible = getDistinctDanToc(khoiData)
  const datasets = labelsDatasetVisible.map((dantoc, i) => {
    const data = khoiData.map(khoi => khoi.dantoc.find(e => e.dantoc_id == dantoc.dantoc_id)?.so_luong || 0)
    return {
      type: 'bar',
      label: dantoc.dan_toc,
      backgroundColor: theme[i],
      data: data
    }
  })
  return {
    labels, datasets
  }
};
const setChartOptionsBar = () => {
  const documentStyle = getComputedStyle(document.documentElement);
  const textColor = documentStyle.getPropertyValue('--body-text-color');
  const textColorSecondary = documentStyle.getPropertyValue('--surface-200');
  const surfaceBorder = documentStyle.getPropertyValue('--border-color');

  return {
    responsive: true,
    maintainAspectRatio: false,
    aspectRatio: 0.8,
    plugins: {
      legend: {
        labels: {
          color: textColor
        }
      },
      datalabels: {
        color: 'white',
        display: function (context) {
          return Math.abs(context.dataset.data[context.dataIndex]) > 15;
        },
        font: {
          weight: 'bold'
        },
        formatter: function (value, context) {
          return Math.abs(value);
        }
      },
    },
    scales: {
      x: {
        ticks: {
          color: textColorSecondary,
          font: {
            weight: 500
          }
        },
        grid: {
          display: false,
          drawBorder: false
        }
      },
      y: {
        ticks: {
          color: textColorSecondary
        },
        grid: {
          color: surfaceBorder,
          drawBorder: false
        }
      }
    }
  };
}
const setChartOptionsHorizontalBar = () => {
  const documentStyle = getComputedStyle(document.documentElement);
  const textColor = documentStyle.getPropertyValue('--body-text-color');
  const textColorSecondary = documentStyle.getPropertyValue('--surface-200');
  const surfaceBorder = documentStyle.getPropertyValue('--border-color');

  return {
    responsive: true,
    indexAxis: 'y',
    maintainAspectRatio: false,
    aspectRatio: 0.8,
    plugins: {
      legend: {
        labels: {
          color: textColor
        }
      },
      datalabels: {
        color: 'white',
        display: function (context) {
          return Math.abs(context.dataset.data[context.dataIndex]) > 15;
        },
        font: {
          weight: 'bold'
        },
        formatter: function (value, context) {
          return Math.abs(value);
        }
      },
    },
    scales: {
      x: {
        ticks: {
          color: textColorSecondary,
          font: {
            weight: 500
          }
        },
        grid: {
          display: false,
          drawBorder: false
        }
      },
      y: {
        ticks: {
          color: textColorSecondary
        },
        grid: {
          color: surfaceBorder,
          drawBorder: false
        }
      }
    }
  };
}

const itemTiTrong = computed(() => {
  const hocSinhGiaoVien = (props.item?.so_luong?.so_hocsinh || 0) / (props.item?.so_luong?.giao_vien || 0)
  const trungBinhHocSinhLop = (props.item?.so_luong?.so_hocsinh || 0) / (props.item?.so_luong?.lop_hoc || 0)
  const trungBinhHocSinhTruong = (props.item?.so_luong?.so_hocsinh || 0) / (props.item?.so_luong.so_truong || 0)
  return [
    {
      ten: 'Số giáo viên/học sinh',
      gia_tri: hocSinhGiaoVien.toFixed(2),
      textColor: 'text-green-500',
      bgColor: 'bg-green-500',
      icon: 'fa fa-chalkboard-user'
    },
    {
      ten: 'Trung bình học sinh/lớp',
      gia_tri: trungBinhHocSinhLop.toFixed(2),
      textColor: 'text-blue-500',
      bgColor: 'bg-blue-500',
      icon: 'fa fa-people-roof'
    },
    {
      ten: 'Trung bình học sinh/trường',
      gia_tri: trungBinhHocSinhTruong.toFixed(2),
      textColor: 'text-orange-500',
      bgColor: 'bg-orange-500',
      icon: 'fa fa-people-group'
    }
  ]
})


const chartDataCapHoc = ref()
const setChartDataCapHoc = () => {
  const theme = chartTheme.theme6
  const capData = props.item.cap_hoc
  const labels = capData.map(e => e.tencap)
  return {
    labels: labels,
    datasets: [
      {
        data: capData.map(e => e.so_truong),
        backgroundColor: capData.map((e, i) => theme[i + 2])
      },
    ]
  }
};
const chartDataLoaiHinh = ref()
const setChartDataLoaiHinh = () => {
  const theme = chartTheme.theme5
  const loaihinhData = props.item.loai_hinh
  const labels = loaihinhData.map(e => e.loaihinh)
  return {
    labels: labels,
    datasets: [
      {
        data: loaihinhData.map(e => e.so_luong),
        backgroundColor: loaihinhData.map((e, i) => theme[i + 2])
      },
    ]
  }
};

const chartDataLopGioiTinh = ref()
const chartOptionsLopGioiTinh = ref()

if (props.item) {

  chartDataGiaoVienTuoiGioiTinh.value = setChartDataGiaoVienTuoiGioiTinh()
  chartOptionsGiaoVienTuoiGioiTinh.value = setChartOptionsGiaoVienTuoiGioiTinh()

  chartDataGiaoVienBoMon.value = setChartDataGiaoVienBoMon()

  chartDataTruongDanToc.value = setChartDataTruongDanToc()
  chartDataTruongGioiTinh.value = setChartDataTruongGioiTinh()

  chartDataCapHoc.value = setChartDataCapHoc()
  chartDataLoaiHinh.value = setChartDataLoaiHinh()

}
</script>

<style></style>